import { MessageT } from "../generated/ln2/message";
import { EncodedMessageContent } from "../generated/ln2/encoded-message-content";
import { OneHotMessageT } from "../generated/ln2/one-hot-message";
import { MessageContent } from "../generated/ln2/message-content";
import { ModifierType } from "../generated/archive/modifier-type";

// ---- Status ---------------------------------------------------------------
import { StatusMessageT } from "../generated/status/status-message";
import { DeviceStatusContent } from "../generated/status/device-status-content";
import { ElevatorStatusMessageT } from "../generated/status/elevator-status-message";
import { EscalatorStatusMessageT } from "../generated/status/escalator-status-message";
import { StatusVariant } from "../generated/status/status-variant";
import { NormalStatusT } from "../generated/status/normal-status";
import { ValuedStatusT } from "../generated/status/valued-status";
import { Status } from "../generated/status/status";

// ---- Traffic --------------------------------------------------------------
import { TrafficMessageT } from "../generated/traffic/traffic-message";
import { DeviceTrafficMessage } from "../generated/traffic/device-traffic-message";
import { ElevatorTrafficMessageT } from "../generated/traffic/elevator-traffic-message";
import { EscalatorTrafficMessageT } from "../generated/traffic/escalator-traffic-message";
import { TrafficVariant } from "../generated/traffic/traffic-variant";
import { NormalTrafficT } from "../generated/traffic/normal-traffic";
import { ValuedTrafficT } from "../generated/traffic/valued-traffic";
import { Traffic } from "../generated/traffic/traffic";

// ---- Usage ----------------------------------------------------------------
import { UsageMessageT } from "../generated/usage/usage-message";
import { DeviceUsageContent } from "../generated/usage/device-usage-content";
import { ElevatorUsageMessageT } from "../generated/usage/elevator-usage-message";
import { EscalatorUsageMessageT } from "../generated/usage/escalator-usage-message";
import { UsageVariant } from "../generated/usage/usage-variant";
import { NormalUsageT } from "../generated/usage/normal-usage";
import { ValuedUsageT } from "../generated/usage/valued-usage";
import { Usage } from "../generated/usage/usage";

// ---- Service --------------------------------------------------------------
import { ServiceMessageT } from "../generated/service/service-message";
import { DeviceServiceContent } from "../generated/service/device-service-content";
import { ElevatorServiceMessageT } from "../generated/service/elevator-service-message";
import { EscalatorServiceMessageT } from "../generated/service/escalator-service-message";
import { ServiceVariant } from "../generated/service/service-variant";
import { NormalServiceT } from "../generated/service/normal-service";
import { ValuedServiceT } from "../generated/service/valued-service";
import { Service } from "../generated/service/service";

// ---- Control --------------------------------------------------------------
import { ControlMessageT } from "../generated/control/control-message";
import { DeviceControlMessage } from "../generated/control/device-control-message";
import { ElevatorControlMessageT } from "../generated/control/elevator-control-message";
import { EscalatorControlMessageT } from "../generated/control/escalator-control-message";
import { ControlVariant } from "../generated/control/control-variant";
import { NormalControlT } from "../generated/control/normal-control";
import { ValuedControlT } from "../generated/control/valued-control";
import { Control } from "../generated/control/control";

// ---- Fault ----------------------------------------------------------------
import { FaultMessageT } from "../generated/fault/fault-message";
import { FaultContent } from "../generated/fault/fault-content";
import { ElevatorFaultMessageT } from "../generated/fault/elevator-fault-message";
import { EscalatorFaultMessageT } from "../generated/fault/escalator-fault-message";
import { FaultVariant } from "../generated/fault/fault-variant";
import { NormalFaultT } from "../generated/fault/normal-fault";
import { ValuedFaultT } from "../generated/fault/valued-fault";
import { Fault } from "../generated/fault/fault";

// ---- GroupSupervisoryStatus ----------------------------------------------
import { GroupSupervisoryStatusMessageT } from "../generated/group-supervisory-status/group-supervisory-status-message";
import { DeviceGroupSupervisoryStatusContent } from "../generated/group-supervisory-status/device-group-supervisory-status-content";
import { ElevatorGroupSupervisoryStatusMessageT } from "../generated/group-supervisory-status/elevator-group-supervisory-status-message";
import { EscalatorGroupSupervisoryStatusMessageT } from "../generated/group-supervisory-status/escalator-group-supervisory-status-message";
import { GroupSupervisoryStatusVariant } from "../generated/group-supervisory-status/group-supervisory-status-variant";
import { NormalGroupSupervisoryStatusT } from "../generated/group-supervisory-status/normal-group-supervisory-status";
import { ValuedGroupSupervisoryStatusT } from "../generated/group-supervisory-status/valued-group-supervisory-status";
import { GroupSupervisoryStatus } from "../generated/group-supervisory-status/group-supervisory-status";

// ---- GroupControl ---------------------------------------------------------
import { GroupControlMessageT } from "../generated/group-control/group-control-message";
import { DeviceGroupControlContent } from "../generated/group-control/device-group-control-content";
import { ElevatorGroupControlMessageT } from "../generated/group-control/elevator-group-control-message";
import { EscalatorGroupControlMessageT } from "../generated/group-control/escalator-group-control-message";
import { GroupControlVariant } from "../generated/group-control/group-control-variant";
import { NormalGroupControlT } from "../generated/group-control/normal-group-control";
import { ValuedGroupControlT } from "../generated/group-control/valued-group-control";
import { GroupControl } from "../generated/group-control/group-control";

// ---- ControllerInfo -------------------------------------------------------
import { ControllerInfoMessageT } from "../generated/controller-info/controller-info-message";
import { DeviceControllerInfoContent } from "../generated/controller-info/device-controller-info-content";
import { ElevatorControllerInfoMessageT } from "../generated/controller-info/elevator-controller-info-message";
import { EscalatorControllerInfoMessageT } from "../generated/controller-info/escalator-controller-info-message";
import { ControllerInfoVariant } from "../generated/controller-info/controller-info-variant";
import { NormalControllerInfoT } from "../generated/controller-info/normal-controller-info";
import { ValuedControllerInfoT } from "../generated/controller-info/valued-controller-info";
import { ControllerInfoContent } from "../generated/controller-info/controller-info-content";
import { FloorLabelMessageT } from "../generated/controller-info/floor-label-message";
import { FirmwareVersionMessageT } from "../generated/controller-info/firmware-version-message";
import { ControllerLabelsMessageT } from "../generated/controller-info/controller-labels-message";
import { FloorLabelsDataMessageT } from "../generated/controller-info/floor-labels-data-message";
import { DispatcherVersionMessageT } from "../generated/controller-info/dispatcher-version-message";
import { ControllerVersionInfoMessageT } from "../generated/controller-info/controller-version-info-message";
import { JobNameMessageT } from "../generated/controller-info/job-name-message";
import { FloorPhysicalOpeningsMessageT } from "../generated/controller-info/floor-physical-openings-message";
import { HallCallEligibilityMessageT } from "../generated/controller-info/hall-call-eligibility-message";
import { ShuttleFloorsMessageT } from "../generated/controller-info/shuttle-floors-message";

// ---- Value ----------------------------------------------------------------
import { Value } from "../generated/value/value";
import { BoolValueT } from "../generated/value/bool-value";
import { ByteValueT } from "../generated/value/byte-value";
import { UByteValueT } from "../generated/value/ubyte-value";
import { ShortValueT } from "../generated/value/short-value";
import { UShortValueT } from "../generated/value/ushort-value";
import { IntValueT } from "../generated/value/int-value";
import { UIntValueT } from "../generated/value/uint-value";
import { LongValueT } from "../generated/value/long-value";
import { ULongValueT } from "../generated/value/ulong-value";
import { FloatValueT } from "../generated/value/float-value";
import { DoubleValueT } from "../generated/value/double-value";
import { StringValueT } from "../generated/value/string-value";

// ===========================================================================
// Value draft (discriminated union over Value union variants)
// ===========================================================================

/**
 * A single typed value in a modifier payload, tagged by its FlatBuffer `Value` variant.
 */
export type ValueDraft =
  | { type: Value.BoolValue; value: boolean }
  | { type: Value.ByteValue; value: number }
  | { type: Value.UByteValue; value: number }
  | { type: Value.ShortValue; value: number }
  | { type: Value.UShortValue; value: number }
  | { type: Value.IntValue; value: number }
  | { type: Value.UIntValue; value: number }
  | { type: Value.LongValue; value: bigint }
  | { type: Value.ULongValue; value: bigint }
  | { type: Value.FloatValue; value: number }
  | { type: Value.DoubleValue; value: number }
  | { type: Value.StringValue; value: string };

export const DEFAULT_VALUE_DRAFT: ValueDraft = { type: Value.IntValue, value: 0 };

interface PackedValue {
  valueType: Value;
  value:
    | BoolValueT
    | ByteValueT
    | UByteValueT
    | ShortValueT
    | UShortValueT
    | IntValueT
    | UIntValueT
    | LongValueT
    | ULongValueT
    | FloatValueT
    | DoubleValueT
    | StringValueT;
}

function packValue(draft: ValueDraft): PackedValue {
  switch (draft.type) {
    case Value.BoolValue:
      return { valueType: Value.BoolValue, value: new BoolValueT(draft.value) };
    case Value.ByteValue:
      return { valueType: Value.ByteValue, value: new ByteValueT(draft.value) };
    case Value.UByteValue:
      return { valueType: Value.UByteValue, value: new UByteValueT(draft.value) };
    case Value.ShortValue:
      return { valueType: Value.ShortValue, value: new ShortValueT(draft.value) };
    case Value.UShortValue:
      return { valueType: Value.UShortValue, value: new UShortValueT(draft.value) };
    case Value.IntValue:
      return { valueType: Value.IntValue, value: new IntValueT(draft.value) };
    case Value.UIntValue:
      return { valueType: Value.UIntValue, value: new UIntValueT(draft.value) };
    case Value.LongValue:
      return { valueType: Value.LongValue, value: new LongValueT(draft.value) };
    case Value.ULongValue:
      return { valueType: Value.ULongValue, value: new ULongValueT(draft.value) };
    case Value.FloatValue:
      return { valueType: Value.FloatValue, value: new FloatValueT(draft.value) };
    case Value.DoubleValue:
      return { valueType: Value.DoubleValue, value: new DoubleValueT(draft.value) };
    case Value.StringValue:
      return { valueType: Value.StringValue, value: new StringValueT(draft.value) };
    default: {
      const exhaustive: never = draft;
      throw new Error(`unreachable Value variant: ${JSON.stringify(exhaustive)}`);
    }
  }
}

// ===========================================================================
// Payload draft — discriminated union over MessageContent variants
// ===========================================================================

/**
 * Which device family a payload targets. Elevators and escalators carry different message sets.
 */
export type DeviceKind = "Elevator" | "Escalator";

interface BaseDraft {
  device: DeviceKind;
  variant: StatusVariant.NormalStatus | StatusVariant.ValuedStatus;
  value: ValueDraft;
}

/**
 * Draft of a Status message payload.
 */
export interface StatusPayloadDraft extends BaseDraft {
  kind: MessageContent.Status_StatusMessage;
  status: Status;
}

/**
 * Draft of a Traffic message payload.
 */
export interface TrafficPayloadDraft extends BaseDraft {
  kind: MessageContent.Traffic_TrafficMessage;
  traffic: Traffic;
  position: number;
}

/**
 * Draft of a Usage message payload.
 */
export interface UsagePayloadDraft extends BaseDraft {
  kind: MessageContent.Usage_UsageMessage;
  usage: Usage;
}

/**
 * Draft of a Service message payload.
 */
export interface ServicePayloadDraft extends BaseDraft {
  kind: MessageContent.Service_ServiceMessage;
  service: Service;
}

/**
 * Draft of a Control message payload — the command direction.
 */
export interface ControlPayloadDraft extends BaseDraft {
  kind: MessageContent.Control_ControlMessage;
  control: Control;
}

/**
 * Draft of a Fault message payload.
 */
export interface FaultPayloadDraft extends BaseDraft {
  kind: MessageContent.Fault_FaultMessage;
  fault: Fault;
}

/**
 * Draft of a Group Supervisory Status payload, which describes a whole bank rather than one car.
 */
export interface GroupSupervisoryStatusPayloadDraft extends BaseDraft {
  kind: MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage;
  groupSupervisoryStatus: GroupSupervisoryStatus;
}

/**
 * Draft of a Group Control payload, addressing a bank rather than one car.
 */
export interface GroupControlPayloadDraft extends BaseDraft {
  kind: MessageContent.GroupControl_GroupControlMessage;
  groupControl: GroupControl;
}

// ControllerInfo's content is a nested union (ControllerInfoContent): one draft
// shape per member, each with distinct fields.
/**
 * The inner content of a Controller Info payload, tagged by its `ControllerInfoContent` variant.
 */
export type ControllerInfoContentDraft =
  | { type: ControllerInfoContent.FloorLabelMessage; floorLabels: string[] }
  | {
      type: ControllerInfoContent.FirmwareVersionMessage;
      major: number;
      minor: number;
      revision: number;
    }
  | { type: ControllerInfoContent.ControllerLabelsMessage; controllerLabels: string }
  | { type: ControllerInfoContent.FloorLabelsDataMessage; floorLabelData: string }
  | { type: ControllerInfoContent.DispatcherVersionMessage; version: string }
  | { type: ControllerInfoContent.ControllerVersionInfoMessage; car: number; version: string }
  | { type: ControllerInfoContent.JobNameMessage; jobName: string }
  | {
      type: ControllerInfoContent.FloorPhysicalOpeningsMessage;
      frontOpenings: boolean[];
      rearOpenings: boolean[];
    }
  | {
      type: ControllerInfoContent.HallCallEligibilityMessage;
      configIndex: number;
      controllerIndex: number;
      downAuxFront: boolean[];
      downAuxRear: boolean[];
      downMainFront: boolean[];
      downMainRear: boolean[];
      upAuxFront: boolean[];
      upAuxRear: boolean[];
      upMainFront: boolean[];
      upMainRear: boolean[];
    }
  | {
      type: ControllerInfoContent.ShuttleFloorsMessage;
      car: number;
      eligibleFloors: boolean[];
      carCallDisposition: number;
    };

/**
 * Draft of a Controller Info payload, such as floor labels.
 */
export interface ControllerInfoPayloadDraft extends BaseDraft {
  kind: MessageContent.ControllerInfo_ControllerInfoMessage;
  content: ControllerInfoContentDraft;
}

/**
 * Any modifier payload draft. The `kind` discriminant is the FlatBuffer `MessageContent`
 * variant, so a schema change to that union surfaces here as a type error.
 */
export type PayloadDraft =
  | StatusPayloadDraft
  | TrafficPayloadDraft
  | UsagePayloadDraft
  | ServicePayloadDraft
  | ControlPayloadDraft
  | FaultPayloadDraft
  | GroupSupervisoryStatusPayloadDraft
  | GroupControlPayloadDraft
  | ControllerInfoPayloadDraft;

// ---- Default factories ----------------------------------------------------

const DEFAULT_BASE: BaseDraft = {
  device: "Elevator",
  variant: StatusVariant.NormalStatus,
  value: DEFAULT_VALUE_DRAFT,
};

const DEFAULT_CONTROLLER_INFO_CONTENT: ControllerInfoContentDraft = {
  type: ControllerInfoContent.JobNameMessage,
  jobName: "",
};

/**
 * An empty draft for the given message kind, with every field at its zero value.
 *
 * The switch has no default arm on purpose: a new `MessageContent` variant must
 * fail to compile here rather than silently fall through to an unrelated payload.
 */
export function defaultPayloadDraft(kind: MessageContent): PayloadDraft {
  switch (kind) {
    case MessageContent.Status_StatusMessage:
      return { ...DEFAULT_BASE, kind, status: Status.NoConnection };
    case MessageContent.Traffic_TrafficMessage:
      return { ...DEFAULT_BASE, kind, traffic: Traffic.P, position: 0 };
    case MessageContent.Usage_UsageMessage:
      return { ...DEFAULT_BASE, kind, usage: Usage.Up };
    case MessageContent.Service_ServiceMessage:
      return { ...DEFAULT_BASE, kind, service: Service.InService };
    case MessageContent.Control_ControlMessage:
      return { ...DEFAULT_BASE, kind, control: Control.CarCallLock };
    case MessageContent.Fault_FaultMessage:
      return { ...DEFAULT_BASE, kind, fault: Fault.LowerPitSwitch };
    case MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage:
      return {
        ...DEFAULT_BASE,
        kind,
        groupSupervisoryStatus: GroupSupervisoryStatus.UpPeak,
      };
    case MessageContent.GroupControl_GroupControlMessage:
      return { ...DEFAULT_BASE, kind, groupControl: GroupControl.SEC };
    case MessageContent.ControllerInfo_ControllerInfoMessage:
      return { ...DEFAULT_BASE, kind, content: { ...DEFAULT_CONTROLLER_INFO_CONTENT } };
    default:
      return {
        ...DEFAULT_BASE,
        kind: MessageContent.Status_StatusMessage,
        status: Status.NoConnection,
      };
  }
}

export const DEFAULT_PAYLOAD_DRAFT: PayloadDraft = defaultPayloadDraft(
  MessageContent.Status_StatusMessage,
);

/**
 * Build a payload draft pre-populated with a specific leaf enum value
 * picked from the `FlatbufferMessagePicker`.
 *
 * Starts from the category's `defaultPayloadDraft` (so device/variant/value
 * land at safe defaults) and overrides the leaf-enum field — `status`,
 * `traffic`, `control`, etc. — with `messageValue` from the picked ref.
 *
 * `ControllerInfo` is the one exception: its leaf is a nested union
 * (`ControllerInfoContent`, one sub-message shape per member), so a single
 * integer can't reconstruct the inner draft. We leave that variant at the
 * default (`JobNameMessage`) and the operator can adjust via the PayloadEditor.
 */
export function payloadDraftFromLeaf(
  messageContent: MessageContent,
  messageValue: number,
): PayloadDraft {
  const base = defaultPayloadDraft(messageContent);
  switch (base.kind) {
    case MessageContent.Status_StatusMessage:
      return { ...base, status: messageValue as Status };
    case MessageContent.Traffic_TrafficMessage:
      return { ...base, traffic: messageValue as Traffic };
    case MessageContent.Usage_UsageMessage:
      return { ...base, usage: messageValue as Usage };
    case MessageContent.Service_ServiceMessage:
      return { ...base, service: messageValue as Service };
    case MessageContent.Control_ControlMessage:
      return { ...base, control: messageValue as Control };
    case MessageContent.Fault_FaultMessage:
      return { ...base, fault: messageValue as Fault };
    case MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage:
      return { ...base, groupSupervisoryStatus: messageValue as GroupSupervisoryStatus };
    case MessageContent.GroupControl_GroupControlMessage:
      return { ...base, groupControl: messageValue as GroupControl };
    case MessageContent.ControllerInfo_ControllerInfoMessage:
      // Leaf maps to a ControllerInfoContent variant whose draft shape
      // is structural — operator configures via the PayloadEditor.
      return base;
    default:
      return base;
  }
}

/**
 * Lookup tables for the per-category slot names inside a saved
 * modifier's payload. The FlatBuffer schema names each category's
 * device-union and variant-union fields after the category itself
 * (`control`/`traffic`/etc.), with the `content` exception for the six
 * categories whose schema field is `content: Device<Cat>Content`. We
 * keep this as data instead of branchy ternaries because the rule of
 * thumb is "never nest ternaries" and a flat object is the cheapest
 * way to express a multi-arm dispatch.
 */
const PAYLOAD_DEVICE_SLOT: Partial<Record<MessageContent, string>> = {
  [MessageContent.Status_StatusMessage]: "content",
  [MessageContent.Traffic_TrafficMessage]: "traffic",
  [MessageContent.Usage_UsageMessage]: "content",
  [MessageContent.Service_ServiceMessage]: "content",
  [MessageContent.Control_ControlMessage]: "control",
  [MessageContent.Fault_FaultMessage]: "content",
  [MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage]: "content",
  [MessageContent.GroupControl_GroupControlMessage]: "content",
};
const PAYLOAD_VARIANT_SLOT: Partial<Record<MessageContent, string>> = {
  [MessageContent.Status_StatusMessage]: "status",
  [MessageContent.Traffic_TrafficMessage]: "traffic",
  [MessageContent.Usage_UsageMessage]: "usage",
  [MessageContent.Service_ServiceMessage]: "service",
  [MessageContent.Control_ControlMessage]: "control",
  [MessageContent.Fault_FaultMessage]: "fault",
  [MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage]: "groupSupervisoryStatus",
  [MessageContent.GroupControl_GroupControlMessage]: "groupControl",
};

/**
 * The floor a `MessageT`-shaped payload addresses: the `position` of an
 * Elevator Control or Elevator Traffic message, or null for every message that
 * carries none (escalator variants, and the Status, Usage and other categories).
 *
 * The expected-step gate compares positions only when both sides carry one, so
 * "no position" is a fact the wizard needs, not a zero.
 */
export function extractPositionFromPayload(payload: unknown): number | null {
  if (typeof payload !== "object" || payload === null) return null;
  const content = (payload as { content?: unknown }).content as
    { messageType?: unknown; message?: unknown } | null | undefined;
  if (!content) return null;
  if (content.messageType === MessageContent.Control_ControlMessage) {
    const control = content.message as ControlMessageT | null | undefined;
    if (control?.controlType !== DeviceControlMessage.ElevatorControlMessage) return null;
    const position = (control.control as ElevatorControlMessageT | null)?.position;
    return typeof position === "number" ? position : null;
  }
  if (content.messageType === MessageContent.Traffic_TrafficMessage) {
    const traffic = content.message as TrafficMessageT | null | undefined;
    if (traffic?.messageType !== DeviceTrafficMessage.ElevatorTrafficMessage) return null;
    const position = (traffic.message as ElevatorTrafficMessageT | null)?.position;
    return typeof position === "number" ? position : null;
  }
  return null;
}

/** The enum value a Normal or Valued variant table carries, or null. */
function variantLeaf(variant: { message?: unknown } | null | undefined): number | null {
  return typeof variant?.message === "number" ? variant.message : null;
}

/**
 * The leaf under one category's device and variant unions, read through the
 * generated Object API field names — which differ per category (`status`,
 * `message`, `fault`, `control`, …), so each arm is typed against its own `*T`
 * and a schema rename breaks the build here rather than silently reading null.
 * Elevator and escalator device tables share their field names per category.
 */
function generatedLeaf(messageContent: MessageContent, message: unknown): number | null {
  if (typeof message !== "object" || message === null) return null;
  switch (messageContent) {
    case MessageContent.Status_StatusMessage: {
      const device = (message as StatusMessageT).status as
        ElevatorStatusMessageT | EscalatorStatusMessageT | null;
      return variantLeaf(device?.status);
    }
    case MessageContent.Traffic_TrafficMessage: {
      const device = (message as TrafficMessageT).message as
        ElevatorTrafficMessageT | EscalatorTrafficMessageT | null;
      return variantLeaf(device?.traffic);
    }
    case MessageContent.Usage_UsageMessage: {
      const device = (message as UsageMessageT).message as
        ElevatorUsageMessageT | EscalatorUsageMessageT | null;
      return variantLeaf(device?.usage);
    }
    case MessageContent.Service_ServiceMessage: {
      const device = (message as ServiceMessageT).message as
        ElevatorServiceMessageT | EscalatorServiceMessageT | null;
      return variantLeaf(device?.message);
    }
    case MessageContent.Control_ControlMessage: {
      const device = (message as ControlMessageT).control as
        ElevatorControlMessageT | EscalatorControlMessageT | null;
      return variantLeaf(device?.control);
    }
    case MessageContent.Fault_FaultMessage: {
      const device = (message as FaultMessageT).fault as
        ElevatorFaultMessageT | EscalatorFaultMessageT | null;
      return variantLeaf(device?.fault);
    }
    case MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage: {
      const device = (message as GroupSupervisoryStatusMessageT).message as
        ElevatorGroupSupervisoryStatusMessageT | EscalatorGroupSupervisoryStatusMessageT | null;
      return variantLeaf(device?.status);
    }
    case MessageContent.GroupControl_GroupControlMessage: {
      const device = (message as GroupControlMessageT).message as
        ElevatorGroupControlMessageT | EscalatorGroupControlMessageT | null;
      return variantLeaf(device?.control);
    }
    default:
      return null;
  }
}

/**
 * Walk a saved modifier's payload (`MessageT`-shaped FlatBuffer unpack
 * output) and return the leaf-enum value that originally produced it,
 * so the wizard's Edit handler can repopulate the Target Message picker
 * without forcing the operator to re-pick what they already chose. The
 * wizard also reads a Sequent adapter's pin messages through it, to know
 * which leaves an observe channel can report.
 *
 * The generated Object API shape is read first, typed per category (see
 * `generatedLeaf`). Only Control's field names ever matched the slot table
 * below, so until that path existed a Status, Traffic or Usage payload
 * came back null. The slot table is kept as the fallback for payload
 * objects in the older shape, where the device union slot is named after
 * the category (`control`, `traffic`) or `content`, and the variant's
 * `.message` field carries the enum value.
 *
 * Returns `null` when the payload is malformed, uses ControllerInfo
 * (whose nested content union doesn't map cleanly to a single enum),
 * or sits in a structure the helper doesn't recognize. Callers fall
 * back to leaving the picker empty so the operator re-picks.
 */
export function extractLeafValueFromPayload(payload: unknown): {
  messageContent: MessageContent;
  messageValue: number;
} | null {
  if (typeof payload !== "object" || payload === null) return null;
  const p = payload as Record<string, unknown>;
  const content = p.content as Record<string, unknown> | undefined;
  if (!content) return null;
  const messageContent = content.messageType as MessageContent | undefined;
  if (typeof messageContent !== "number" || messageContent === MessageContent.NONE) {
    return null;
  }
  const message = content.message as Record<string, unknown> | undefined;
  if (!message) return null;

  const generated = generatedLeaf(messageContent, message);
  if (generated !== null) return { messageContent, messageValue: generated };

  const deviceSlot = PAYLOAD_DEVICE_SLOT[messageContent];
  const variantSlot = PAYLOAD_VARIANT_SLOT[messageContent];
  if (!deviceSlot || !variantSlot) return null;
  const deviceMessage = message[deviceSlot] as Record<string, unknown> | undefined;
  if (!deviceMessage) return null;
  const variantTable = deviceMessage[variantSlot] as Record<string, unknown> | undefined;
  if (!variantTable) return null;
  const messageValue = variantTable.message as number | undefined;
  if (typeof messageValue !== "number") return null;
  return { messageContent, messageValue };
}

// ===========================================================================
// Generic helpers for the 8 simple variants
// ===========================================================================

function packNormalOrValued<NormalT, ValuedT>(
  draft: BaseDraft,
  enumValue: number,
  makeNormal: (e: number) => NormalT,
  makeValued: (e: number, vt: Value, v: PackedValue["value"]) => ValuedT,
): { variantType: number; variant: NormalT | ValuedT } {
  if (draft.variant === StatusVariant.ValuedStatus) {
    const packed = packValue(draft.value);
    return {
      variantType: StatusVariant.ValuedStatus,
      variant: makeValued(enumValue, packed.valueType, packed.value),
    };
  }
  return {
    variantType: StatusVariant.NormalStatus,
    variant: makeNormal(enumValue),
  };
}

// ===========================================================================
// Per-variant builders
// ===========================================================================

function buildStatusMessage(draft: StatusPayloadDraft): StatusMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.status,
    (e) => new NormalStatusT(e),
    (e, vt, v) => new ValuedStatusT(e, vt, v as ValuedStatusT["value"]),
  );
  const inner =
    draft.device === "Elevator"
      ? new ElevatorStatusMessageT(packed.variantType, packed.variant)
      : new EscalatorStatusMessageT(packed.variantType, packed.variant);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceStatusContent.ElevatorStatusMessage
      : DeviceStatusContent.EscalatorStatusMessage;
  return new StatusMessageT(deviceUnion, inner);
}

function buildTrafficMessage(draft: TrafficPayloadDraft): TrafficMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.traffic,
    (e) => new NormalTrafficT(e),
    (e, vt, v) => new ValuedTrafficT(e, vt, v as ValuedTrafficT["value"]),
  );
  const traffic = packed.variant as NormalTrafficT | ValuedTrafficT;
  const variantType = packed.variantType as TrafficVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorTrafficMessageT(variantType, traffic, draft.position)
      : new EscalatorTrafficMessageT(variantType, traffic);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceTrafficMessage.ElevatorTrafficMessage
      : DeviceTrafficMessage.EscalatorTrafficMessage;
  return new TrafficMessageT(deviceUnion, inner);
}

function buildUsageMessage(draft: UsagePayloadDraft): UsageMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.usage,
    (e) => new NormalUsageT(e),
    (e, vt, v) => new ValuedUsageT(e, vt, v as ValuedUsageT["value"]),
  );
  const usage = packed.variant as NormalUsageT | ValuedUsageT;
  const variantType = packed.variantType as UsageVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorUsageMessageT(variantType, usage)
      : new EscalatorUsageMessageT(variantType, usage);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceUsageContent.ElevatorUsageMessage
      : DeviceUsageContent.EscalatorUsageMessage;
  return new UsageMessageT(deviceUnion, inner);
}

function buildServiceMessage(draft: ServicePayloadDraft): ServiceMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.service,
    (e) => new NormalServiceT(e),
    (e, vt, v) => new ValuedServiceT(e, vt, v as ValuedServiceT["value"]),
  );
  const service = packed.variant as NormalServiceT | ValuedServiceT;
  const variantType = packed.variantType as ServiceVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorServiceMessageT(variantType, service)
      : new EscalatorServiceMessageT(variantType, service);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceServiceContent.ElevatorServiceMessage
      : DeviceServiceContent.EscalatorServiceMessage;
  return new ServiceMessageT(deviceUnion, inner);
}

function buildControlMessage(draft: ControlPayloadDraft): ControlMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.control,
    (e) => new NormalControlT(e),
    (e, vt, v) => new ValuedControlT(e, vt, v as ValuedControlT["value"]),
  );
  const control = packed.variant as NormalControlT | ValuedControlT;
  const variantType = packed.variantType as ControlVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorControlMessageT(variantType, control)
      : new EscalatorControlMessageT(variantType, control);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceControlMessage.ElevatorControlMessage
      : DeviceControlMessage.EscalatorControlMessage;
  return new ControlMessageT(deviceUnion, inner);
}

function buildFaultMessage(draft: FaultPayloadDraft): FaultMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.fault,
    (e) => new NormalFaultT(e),
    (e, vt, v) => new ValuedFaultT(e, vt, v as ValuedFaultT["value"]),
  );
  const fault = packed.variant as NormalFaultT | ValuedFaultT;
  const variantType = packed.variantType as FaultVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorFaultMessageT(variantType, fault)
      : new EscalatorFaultMessageT(variantType, fault);
  const deviceUnion =
    draft.device === "Elevator"
      ? FaultContent.ElevatorFaultMessage
      : FaultContent.EscalatorFaultMessage;
  return new FaultMessageT(deviceUnion, inner);
}

function buildGroupSupervisoryStatusMessage(
  draft: GroupSupervisoryStatusPayloadDraft,
): GroupSupervisoryStatusMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.groupSupervisoryStatus,
    (e) => new NormalGroupSupervisoryStatusT(e),
    (e, vt, v) =>
      new ValuedGroupSupervisoryStatusT(e, vt, v as ValuedGroupSupervisoryStatusT["value"]),
  );
  const groupSup = packed.variant as NormalGroupSupervisoryStatusT | ValuedGroupSupervisoryStatusT;
  const variantType = packed.variantType as GroupSupervisoryStatusVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorGroupSupervisoryStatusMessageT(variantType, groupSup)
      : new EscalatorGroupSupervisoryStatusMessageT(variantType, groupSup);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceGroupSupervisoryStatusContent.ElevatorGroupSupervisoryStatusMessage
      : DeviceGroupSupervisoryStatusContent.EscalatorGroupSupervisoryStatusMessage;
  return new GroupSupervisoryStatusMessageT(deviceUnion, inner);
}

function buildGroupControlMessage(draft: GroupControlPayloadDraft): GroupControlMessageT {
  const packed = packNormalOrValued(
    draft,
    draft.groupControl,
    (e) => new NormalGroupControlT(e),
    (e, vt, v) => new ValuedGroupControlT(e, vt, v as ValuedGroupControlT["value"]),
  );
  const groupCtl = packed.variant as NormalGroupControlT | ValuedGroupControlT;
  const variantType = packed.variantType as GroupControlVariant;
  const inner =
    draft.device === "Elevator"
      ? new ElevatorGroupControlMessageT(variantType, groupCtl)
      : new EscalatorGroupControlMessageT(variantType, groupCtl);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceGroupControlContent.ElevatorGroupControlMessage
      : DeviceGroupControlContent.EscalatorGroupControlMessage;
  return new GroupControlMessageT(deviceUnion, inner);
}

// ---- ControllerInfo: build the inner content union --------------------------

type ControllerInfoInnerT =
  | FloorLabelMessageT
  | FirmwareVersionMessageT
  | ControllerLabelsMessageT
  | FloorLabelsDataMessageT
  | DispatcherVersionMessageT
  | ControllerVersionInfoMessageT
  | JobNameMessageT
  | FloorPhysicalOpeningsMessageT
  | HallCallEligibilityMessageT
  | ShuttleFloorsMessageT;

function buildControllerInfoContent(content: ControllerInfoContentDraft): {
  messageType: ControllerInfoContent;
  message: ControllerInfoInnerT;
} {
  switch (content.type) {
    case ControllerInfoContent.FloorLabelMessage:
      return {
        messageType: content.type,
        message: new FloorLabelMessageT(content.floorLabels),
      };
    case ControllerInfoContent.FirmwareVersionMessage:
      return {
        messageType: content.type,
        message: new FirmwareVersionMessageT(content.major, content.minor, content.revision),
      };
    case ControllerInfoContent.ControllerLabelsMessage:
      return {
        messageType: content.type,
        message: new ControllerLabelsMessageT(content.controllerLabels),
      };
    case ControllerInfoContent.FloorLabelsDataMessage:
      return {
        messageType: content.type,
        message: new FloorLabelsDataMessageT(content.floorLabelData),
      };
    case ControllerInfoContent.DispatcherVersionMessage:
      return {
        messageType: content.type,
        message: new DispatcherVersionMessageT(content.version),
      };
    case ControllerInfoContent.ControllerVersionInfoMessage:
      return {
        messageType: content.type,
        message: new ControllerVersionInfoMessageT(content.car, content.version),
      };
    case ControllerInfoContent.JobNameMessage:
      return {
        messageType: content.type,
        message: new JobNameMessageT(content.jobName),
      };
    case ControllerInfoContent.FloorPhysicalOpeningsMessage:
      return {
        messageType: content.type,
        message: new FloorPhysicalOpeningsMessageT(content.frontOpenings, content.rearOpenings),
      };
    case ControllerInfoContent.HallCallEligibilityMessage:
      return {
        messageType: content.type,
        message: new HallCallEligibilityMessageT(
          content.configIndex,
          content.controllerIndex,
          content.downAuxFront,
          content.downAuxRear,
          content.downMainFront,
          content.downMainRear,
          content.upAuxFront,
          content.upAuxRear,
          content.upMainFront,
          content.upMainRear,
        ),
      };
    case ControllerInfoContent.ShuttleFloorsMessage:
      return {
        messageType: content.type,
        message: new ShuttleFloorsMessageT(
          content.car,
          content.eligibleFloors,
          content.carCallDisposition,
        ),
      };
    default: {
      const exhaustive: never = content;
      throw new Error(`unreachable ControllerInfoContent variant: ${JSON.stringify(exhaustive)}`);
    }
  }
}

function buildControllerInfoMessage(draft: ControllerInfoPayloadDraft): ControllerInfoMessageT {
  const innerContent = buildControllerInfoContent(draft.content);
  const variantInner =
    draft.variant === StatusVariant.ValuedStatus
      ? (() => {
          const packed = packValue(draft.value);
          return new ValuedControllerInfoT(
            innerContent.messageType,
            innerContent.message,
            packed.valueType,
            packed.value as ValuedControllerInfoT["value"],
          );
        })()
      : new NormalControllerInfoT(innerContent.messageType, innerContent.message);
  const variantType =
    draft.variant === StatusVariant.ValuedStatus
      ? ControllerInfoVariant.ValuedControllerInfo
      : ControllerInfoVariant.NormalControllerInfo;
  const deviceMessage =
    draft.device === "Elevator"
      ? new ElevatorControllerInfoMessageT(variantType, variantInner)
      : new EscalatorControllerInfoMessageT(variantType, variantInner);
  const deviceUnion =
    draft.device === "Elevator"
      ? DeviceControllerInfoContent.ElevatorControllerInfoMessage
      : DeviceControllerInfoContent.EscalatorControllerInfoMessage;
  return new ControllerInfoMessageT(deviceUnion, deviceMessage);
}

// ===========================================================================
// Top-level builder
// ===========================================================================

function buildContentT(draft: PayloadDraft): {
  messageType: MessageContent;
  message: OneHotMessageT["message"];
} {
  switch (draft.kind) {
    case MessageContent.Status_StatusMessage:
      return { messageType: draft.kind, message: buildStatusMessage(draft) };
    case MessageContent.Traffic_TrafficMessage:
      return { messageType: draft.kind, message: buildTrafficMessage(draft) };
    case MessageContent.Usage_UsageMessage:
      return { messageType: draft.kind, message: buildUsageMessage(draft) };
    case MessageContent.Service_ServiceMessage:
      return { messageType: draft.kind, message: buildServiceMessage(draft) };
    case MessageContent.Control_ControlMessage:
      return { messageType: draft.kind, message: buildControlMessage(draft) };
    case MessageContent.Fault_FaultMessage:
      return { messageType: draft.kind, message: buildFaultMessage(draft) };
    case MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage:
      return { messageType: draft.kind, message: buildGroupSupervisoryStatusMessage(draft) };
    case MessageContent.GroupControl_GroupControlMessage:
      return { messageType: draft.kind, message: buildGroupControlMessage(draft) };
    case MessageContent.ControllerInfo_ControllerInfoMessage:
      return { messageType: draft.kind, message: buildControllerInfoMessage(draft) };
    default: {
      const exhaustive: never = draft;
      throw new Error(`unreachable PayloadDraft kind: ${JSON.stringify(exhaustive)}`);
    }
  }
}

/**
 * Packs a draft into the generated FlatBuffer Object API type for the wire.
 *
 * Builds `*T` values and returns them for `pack()`; nothing here hand-assembles
 * offsets, so a schema change breaks this at compile time.
 */
export function buildMessageT(
  modifierType: ModifierType,
  draft: PayloadDraft | null,
): MessageT | null {
  if (modifierType === ModifierType.IN_FLIGHT) return null;
  if (draft === null) return null;

  const { messageType, message } = buildContentT(draft);
  const oneHot = new OneHotMessageT(messageType, message);
  return new MessageT(EncodedMessageContent.OneHotMessage, oneHot);
}

// ===========================================================================
// Message content type support helpers
// ===========================================================================

/**
 * Returns true if the given MessageContent variant has a typed payload editor.
 * After this rewrite, ALL non-NONE variants are supported.
 */
export function isSupportedTargetMessageType(target: MessageContent): boolean {
  switch (target) {
    case MessageContent.Status_StatusMessage:
    case MessageContent.Traffic_TrafficMessage:
    case MessageContent.Usage_UsageMessage:
    case MessageContent.Service_ServiceMessage:
    case MessageContent.Control_ControlMessage:
    case MessageContent.Fault_FaultMessage:
    case MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage:
    case MessageContent.GroupControl_GroupControlMessage:
    case MessageContent.ControllerInfo_ControllerInfoMessage:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if the given MessageContent variant carries payload data the
 * user must specify. Currently true for all real variants; NONE returns false.
 */
export function messageContentHasPayload(target: MessageContent): boolean {
  return target !== MessageContent.NONE;
}

/**
 * Returns true when the operator still has payload-side fields to fill in
 * AFTER picking the leaf via the Target Message picker. Used by the wizard
 * to decide whether to render the Payload section at all.
 *
 * Most categories collapse to nothing once the leaf is picked — the leaf
 * enum value the picker emits IS the entire payload. The two exceptions:
 *
 *   - **Traffic** carries a `position` field on its elevator inner message
 *     that the wizard still has to surface (runtime value transforms only
 *     handle Control-side position currently).
 *   - **ControllerInfo** carries a nested content union — the picker
 *     chooses *which* sub-message (FloorLabels / FirmwareVersion / …),
 *     but the actual data inside that sub-message still needs the
 *     operator to fill it in.
 *
 * NONE / unsupported targets always return false; the caller already gates
 * the section on `isSupportedTargetMessageType` and a non-null ref.
 */
export function targetMessageHasOperatorInputs(target: MessageContent): boolean {
  return (
    target === MessageContent.Traffic_TrafficMessage ||
    target === MessageContent.ControllerInfo_ControllerInfoMessage
  );
}
